import config from '~/config';
import { getAxios } from './axios';

class HttpApiClient {
  constructor() {
    this.post = this.post.bind(this);
  }

  async post(path: string, body?: any) {
    const axios = await getAxios();
    const { status, data } = await axios({
      method: 'POST',
      baseURL: config.BFF_BASE_URL,
      url: path,
      data: body ? JSON.stringify(body) : undefined,
      headers: { 'Content-Type': 'application/json' },
    });

    return { status, data };
  }
}

const client = new HttpApiClient();
export default client;
